import { Injectable, Renderer2 } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FloatingLabelService1Service {
  funOne(
    appPaymentsFloatingLabel: HTMLElement | null | undefined,
    element_ref: string,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    renderer: Renderer2
  ) {
    if (element_ref) {
      renderer.setAttribute(
        appPaymentsFloatingLabel,
        'for',
        element_ref.trim()
      );
    }
    renderer.addClass(appPaymentsFloatingLabel, 'floatinglabel');
  }

  funTwo(
    placeholder: string,
    placeholderValue: string | undefined,
    placeHolderLabel: string | undefined,
    elementFunTwo: string | undefined,
    labelvalue: string | undefined
  ) {
    if (!placeholderValue) {
      placeHolderLabel =
        placeholder && placeholder.trim() !== '' ? elementFunTwo : '';
    } else {
      placeHolderLabel = placeholderValue;
    }
    this.funThree(placeHolderLabel, labelvalue);
  }

  funThree(
    placeHolderLabel: string | undefined,
    labelvalue: string | undefined
  ) {
    if (!labelvalue) {
      labelvalue = placeHolderLabel;
    }
  }

  funFour(
    textLabel: unknown,
    labelvalue: string | undefined,
    isRequired: boolean,
    isOptional: boolean,
    appPaymentsFloatingLabel: HTMLElement | null | undefined,
    elementFunFourRef: unknown,
    renderer: Renderer2
  ) {
    textLabel = renderer.createText(
      labelvalue +
        (isRequired ? ' (Required)' : '') +
        (isOptional ? ' (Optional)' : '')
    );
    renderer.appendChild(appPaymentsFloatingLabel, textLabel);
    renderer.insertBefore(
      renderer.parentNode(elementFunFourRef),
      appPaymentsFloatingLabel,
      elementFunFourRef
    );
  }

  funFive(
    placeHolderLabel: string | undefined,
    isOptionalforPlaceholder: boolean,
    isRequiredforPlaceholder: boolean,
    placeholderValue: string | undefined,
    elementRefFunFive: unknown,
    renderer: Renderer2
  ) {
    if (
      (placeHolderLabel !== '' && isOptionalforPlaceholder) ||
      isRequiredforPlaceholder
    ) {
      this.passPlaceholderLable(
        placeHolderLabel,
        placeholderValue,
        isRequiredforPlaceholder,
        isOptionalforPlaceholder,
        elementRefFunFive,
        renderer
      );
    }
  }

  passPlaceholderLable(
    placeHolderLabel: string | undefined,
    placeholderValue: string | undefined,
    isRequiredforPlaceholder: boolean,
    isOptionalforPlaceholder: boolean,
    elementRefFunFive: unknown,
    renderer: Renderer2
  ) {
    placeHolderLabel =
      placeholderValue +
      (isRequiredforPlaceholder ? ' (Required)' : '') +
      (isOptionalforPlaceholder ? ' (Optional)' : '');
    renderer.setAttribute(
      elementRefFunFive,
      'placeholder',
      placeHolderLabel.trim()
    );
  }
}
